import { Component, Inject, inject, Input, OnInit } from "@angular/core"
import { MatButtonModule } from "@angular/material/button"
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from "@angular/material/dialog"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { Store } from "@ngrx/store"
import { RootState } from "../../../reducers/root.reducer"

export type InfoDialogInput = {
    title: string
    text: string
    infoType?: "info" | "warning" | "error"
    closeBtnText?: string
    closeBtnColorOverride?: string
}

@Component({
    selector: "hs-info-popup",
    templateUrl: "./info-popup.component.html",
    styleUrls: ["./info-popup.component.sass"],
    standalone: true,
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogTitle,
        MatDialogContent,
    ],
})
export class InfoPopupComponent implements OnInit {
    readonly dialog = inject(MatDialog)

    @Input()
    public title: string = "Info"
    @Input()
    public text: string
    @Input()
    public infoType: "info" | "warning" | "error"
    @Input()
    public closeBtnText: string = "Close"
    @Input()
    public closeBtnColorOverride: string

    public constructor(
        public store: Store<RootState>,
        @Inject(MAT_DIALOG_DATA) public data: InfoDialogInput
    ) {}

    ngOnInit() {}
}
